/**
 * extractExcerpt.ts — TipTap-JSON zu Plaintext-Extraktor
 *
 * Traversiert ein TipTap-Dokument (ProseMirror JSON) und extrahiert die
 * ersten N Zeichen als Plaintext fuer Report-Card-Previews.
 */

interface TipTapNode {
  type: string
  text?: string
  content?: TipTapNode[]
  attrs?: Record<string, unknown>
}

/**
 * Extrahiert die ersten `maxLen` Zeichen aus einem TipTap-JSON-Dokument.
 * Ignoriert Bilder, Views und andere Non-Text-Nodes.
 */
export function extractExcerpt(
  doc: { type?: string; content?: TipTapNode[] } | null | undefined,
  maxLen = 120,
): string {
  if (!doc?.content) return ''

  let result = ''

  function walk(nodes: TipTapNode[]) {
    for (const node of nodes) {
      if (result.length >= maxLen) return

      // Text-Node: direkt anfuegen
      if (node.text) {
        result += node.text
        continue
      }

      // Block-Level-Nodes (paragraph, heading, listItem, etc.) mit
      // Zeilenumbruch-Separator, damit Saetze nicht zusammenkleben
      if (
        node.type === 'paragraph' ||
        node.type === 'heading' ||
        node.type === 'listItem' ||
        node.type === 'blockquote'
      ) {
        if (result.length > 0 && !result.endsWith(' ')) {
          result += ' '
        }
      }

      // Rekursiv in children absteigen
      if (node.content) {
        walk(node.content)
      }
    }
  }

  walk(doc.content)

  // Trimmen und ggf. kuerzen
  result = result.trim()
  if (result.length > maxLen) {
    // Am letzten Wort-Ende vor maxLen abschneiden
    const cut = result.lastIndexOf(' ', maxLen)
    result = result.slice(0, cut > maxLen * 0.5 ? cut : maxLen) + '…'
  }

  return result
}
